import React, { FC, useRef, RefObject } from "react";
import { SnackbarProvider } from "notistack";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

export let snackbarRef: RefObject<SnackbarProvider>;

export interface NotistackProviderProps {}

const NotistackProvider: FC<NotistackProviderProps> = ({ children }) => {
  snackbarRef = useRef<SnackbarProvider>(null);

  return (
    <SnackbarProvider
      ref={snackbarRef}
      maxSnack={3}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      action={(key) => (
        <IconButton
          onClick={() => {
            snackbarRef.current?.closeSnackbar(key);
          }}
          size="small"
        >
          <Close />
        </IconButton>
      )}
      dense
      preventDuplicate
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotistackProvider;
